export interface CountryCode {
  code: string // 国コード (例: JP, US)
  name: string // 国名（日本語）
  nameEn: string // 国名（英語）
  dialCode: string // 国番号 (例: +81)
  flag: string // 国旗絵文字
}

// 全カ国の国番号リスト（主要国を含む全カ国対応）
export const countryCodeList: CountryCode[] = [
  { code: 'JP', name: '日本', nameEn: 'Japan', dialCode: '+81', flag: '🇯🇵' },
  {
    code: 'US',
    name: 'アメリカ',
    nameEn: 'United States',
    dialCode: '+1',
    flag: '🇺🇸'
  },
  {
    code: 'GB',
    name: 'イギリス',
    nameEn: 'United Kingdom',
    dialCode: '+44',
    flag: '🇬🇧'
  },
  { code: 'CN', name: '中国', nameEn: 'China', dialCode: '+86', flag: '🇨🇳' },
  {
    code: 'KR',
    name: '韓国',
    nameEn: 'South Korea',
    dialCode: '+82',
    flag: '🇰🇷'
  },
  {
    code: 'AU',
    name: 'オーストラリア',
    nameEn: 'Australia',
    dialCode: '+61',
    flag: '🇦🇺'
  },
  { code: 'CA', name: 'カナダ', nameEn: 'Canada', dialCode: '+1', flag: '🇨🇦' },
  {
    code: 'DE',
    name: 'ドイツ',
    nameEn: 'Germany',
    dialCode: '+49',
    flag: '🇩🇪'
  },
  {
    code: 'FR',
    name: 'フランス',
    nameEn: 'France',
    dialCode: '+33',
    flag: '🇫🇷'
  },
  {
    code: 'IT',
    name: 'イタリア',
    nameEn: 'Italy',
    dialCode: '+39',
    flag: '🇮🇹'
  },
  {
    code: 'ES',
    name: 'スペイン',
    nameEn: 'Spain',
    dialCode: '+34',
    flag: '🇪🇸'
  },
  {
    code: 'BR',
    name: 'ブラジル',
    nameEn: 'Brazil',
    dialCode: '+55',
    flag: '🇧🇷'
  },
  { code: 'IN', name: 'インド', nameEn: 'India', dialCode: '+91', flag: '🇮🇳' },
  { code: 'RU', name: 'ロシア', nameEn: 'Russia', dialCode: '+7', flag: '🇷🇺' },
  {
    code: 'MX',
    name: 'メキシコ',
    nameEn: 'Mexico',
    dialCode: '+52',
    flag: '🇲🇽'
  },
  {
    code: 'ID',
    name: 'インドネシア',
    nameEn: 'Indonesia',
    dialCode: '+62',
    flag: '🇮🇩'
  },
  {
    code: 'NL',
    name: 'オランダ',
    nameEn: 'Netherlands',
    dialCode: '+31',
    flag: '🇳🇱'
  },
  { code: 'TR', name: 'トルコ', nameEn: 'Turkey', dialCode: '+90', flag: '🇹🇷' },
  {
    code: 'SA',
    name: 'サウジアラビア',
    nameEn: 'Saudi Arabia',
    dialCode: '+966',
    flag: '🇸🇦'
  },
  {
    code: 'CH',
    name: 'スイス',
    nameEn: 'Switzerland',
    dialCode: '+41',
    flag: '🇨🇭'
  },
  {
    code: 'AR',
    name: 'アルゼンチン',
    nameEn: 'Argentina',
    dialCode: '+54',
    flag: '🇦🇷'
  },
  {
    code: 'SE',
    name: 'スウェーデン',
    nameEn: 'Sweden',
    dialCode: '+46',
    flag: '🇸🇪'
  },
  {
    code: 'PL',
    name: 'ポーランド',
    nameEn: 'Poland',
    dialCode: '+48',
    flag: '🇵🇱'
  },
  {
    code: 'BE',
    name: 'ベルギー',
    nameEn: 'Belgium',
    dialCode: '+32',
    flag: '🇧🇪'
  },
  {
    code: 'NO',
    name: 'ノルウェー',
    nameEn: 'Norway',
    dialCode: '+47',
    flag: '🇳🇴'
  },
  {
    code: 'AT',
    name: 'オーストリア',
    nameEn: 'Austria',
    dialCode: '+43',
    flag: '🇦🇹'
  },
  {
    code: 'AE',
    name: 'アラブ首長国連邦',
    nameEn: 'United Arab Emirates',
    dialCode: '+971',
    flag: '🇦🇪'
  },
  { code: 'TH', name: 'タイ', nameEn: 'Thailand', dialCode: '+66', flag: '🇹🇭' },
  {
    code: 'SG',
    name: 'シンガポール',
    nameEn: 'Singapore',
    dialCode: '+65',
    flag: '🇸🇬'
  },
  {
    code: 'MY',
    name: 'マレーシア',
    nameEn: 'Malaysia',
    dialCode: '+60',
    flag: '🇲🇾'
  },
  {
    code: 'PH',
    name: 'フィリピン',
    nameEn: 'Philippines',
    dialCode: '+63',
    flag: '🇵🇭'
  },
  {
    code: 'VN',
    name: 'ベトナム',
    nameEn: 'Vietnam',
    dialCode: '+84',
    flag: '🇻🇳'
  },
  {
    code: 'NZ',
    name: 'ニュージーランド',
    nameEn: 'New Zealand',
    dialCode: '+64',
    flag: '🇳🇿'
  },
  {
    code: 'DK',
    name: 'デンマーク',
    nameEn: 'Denmark',
    dialCode: '+45',
    flag: '🇩🇰'
  },
  {
    code: 'FI',
    name: 'フィンランド',
    nameEn: 'Finland',
    dialCode: '+358',
    flag: '🇫🇮'
  },
  {
    code: 'IE',
    name: 'アイルランド',
    nameEn: 'Ireland',
    dialCode: '+353',
    flag: '🇮🇪'
  },
  {
    code: 'PT',
    name: 'ポルトガル',
    nameEn: 'Portugal',
    dialCode: '+351',
    flag: '🇵🇹'
  },
  {
    code: 'GR',
    name: 'ギリシャ',
    nameEn: 'Greece',
    dialCode: '+30',
    flag: '🇬🇷'
  },
  {
    code: 'CZ',
    name: 'チェコ',
    nameEn: 'Czech Republic',
    dialCode: '+420',
    flag: '🇨🇿'
  },
  {
    code: 'RO',
    name: 'ルーマニア',
    nameEn: 'Romania',
    dialCode: '+40',
    flag: '🇷🇴'
  },
  {
    code: 'HU',
    name: 'ハンガリー',
    nameEn: 'Hungary',
    dialCode: '+36',
    flag: '🇭🇺'
  },
  {
    code: 'IL',
    name: 'イスラエル',
    nameEn: 'Israel',
    dialCode: '+972',
    flag: '🇮🇱'
  },
  {
    code: 'ZA',
    name: '南アフリカ',
    nameEn: 'South Africa',
    dialCode: '+27',
    flag: '🇿🇦'
  },
  { code: 'CL', name: 'チリ', nameEn: 'Chile', dialCode: '+56', flag: '🇨🇱' },
  {
    code: 'CO',
    name: 'コロンビア',
    nameEn: 'Colombia',
    dialCode: '+57',
    flag: '🇨🇴'
  },
  { code: 'PE', name: 'ペルー', nameEn: 'Peru', dialCode: '+51', flag: '🇵🇪' },
  {
    code: 'EG',
    name: 'エジプト',
    nameEn: 'Egypt',
    dialCode: '+20',
    flag: '🇪🇬'
  },
  {
    code: 'PK',
    name: 'パキスタン',
    nameEn: 'Pakistan',
    dialCode: '+92',
    flag: '🇵🇰'
  },
  {
    code: 'BD',
    name: 'バングラデシュ',
    nameEn: 'Bangladesh',
    dialCode: '+880',
    flag: '🇧🇩'
  },
  {
    code: 'NG',
    name: 'ナイジェリア',
    nameEn: 'Nigeria',
    dialCode: '+234',
    flag: '🇳🇬'
  },
  { code: 'KE', name: 'ケニア', nameEn: 'Kenya', dialCode: '+254', flag: '🇰🇪' },
  {
    code: 'ET',
    name: 'エチオピア',
    nameEn: 'Ethiopia',
    dialCode: '+251',
    flag: '🇪🇹'
  },
  { code: 'GH', name: 'ガーナ', nameEn: 'Ghana', dialCode: '+233', flag: '🇬🇭' },
  {
    code: 'TZ',
    name: 'タンザニア',
    nameEn: 'Tanzania',
    dialCode: '+255',
    flag: '🇹🇿'
  },
  {
    code: 'UG',
    name: 'ウガンダ',
    nameEn: 'Uganda',
    dialCode: '+256',
    flag: '🇺🇬'
  },
  {
    code: 'AO',
    name: 'アンゴラ',
    nameEn: 'Angola',
    dialCode: '+244',
    flag: '🇦🇴'
  },
  {
    code: 'MZ',
    name: 'モザンビーク',
    nameEn: 'Mozambique',
    dialCode: '+258',
    flag: '🇲🇿'
  },
  {
    code: 'MW',
    name: 'マラウィ',
    nameEn: 'Malawi',
    dialCode: '+265',
    flag: '🇲🇼'
  },
  {
    code: 'ZM',
    name: 'ザンビア',
    nameEn: 'Zambia',
    dialCode: '+260',
    flag: '🇿🇲'
  },
  {
    code: 'SN',
    name: 'セネガル',
    nameEn: 'Senegal',
    dialCode: '+221',
    flag: '🇸🇳'
  },
  {
    code: 'CI',
    name: 'コートジボワール',
    nameEn: 'Côte d\'Ivoire',
    dialCode: '+225',
    flag: '🇨🇮'
  },
  {
    code: 'CM',
    name: 'カメルーン',
    nameEn: 'Cameroon',
    dialCode: '+237',
    flag: '🇨🇲'
  },
  {
    code: 'MG',
    name: 'マダガスカル',
    nameEn: 'Madagascar',
    dialCode: '+261',
    flag: '🇲🇬'
  },
  {
    code: 'NE',
    name: 'ニジェール',
    nameEn: 'Niger',
    dialCode: '+227',
    flag: '🇳🇪'
  },
  {
    code: 'BF',
    name: 'ブルキナファソ',
    nameEn: 'Burkina Faso',
    dialCode: '+226',
    flag: '🇧🇫'
  },
  { code: 'ML', name: 'マリ', nameEn: 'Mali', dialCode: '+223', flag: '🇲🇱' },
  { code: 'TD', name: 'チャド', nameEn: 'Chad', dialCode: '+235', flag: '🇹🇩' },
  {
    code: 'SO',
    name: 'ソマリア',
    nameEn: 'Somalia',
    dialCode: '+252',
    flag: '🇸🇴'
  },
  {
    code: 'CF',
    name: '中央アフリカ',
    nameEn: 'Central African Republic',
    dialCode: '+236',
    flag: '🇨🇫'
  },
  {
    code: 'SD',
    name: 'スーダン',
    nameEn: 'Sudan',
    dialCode: '+249',
    flag: '🇸🇩'
  },
  {
    code: 'ER',
    name: 'エリトリア',
    nameEn: 'Eritrea',
    dialCode: '+291',
    flag: '🇪🇷'
  },
  {
    code: 'DJ',
    name: 'ジブチ',
    nameEn: 'Djibouti',
    dialCode: '+253',
    flag: '🇩🇯'
  },
  {
    code: 'RW',
    name: 'ルワンダ',
    nameEn: 'Rwanda',
    dialCode: '+250',
    flag: '🇷🇼'
  },
  {
    code: 'BI',
    name: 'ブルンジ',
    nameEn: 'Burundi',
    dialCode: '+257',
    flag: '🇧🇮'
  },
  {
    code: 'SS',
    name: '南スーダン',
    nameEn: 'South Sudan',
    dialCode: '+211',
    flag: '🇸🇸'
  },
  { code: 'LY', name: 'リビア', nameEn: 'Libya', dialCode: '+218', flag: '🇱🇾' },
  {
    code: 'TN',
    name: 'チュニジア',
    nameEn: 'Tunisia',
    dialCode: '+216',
    flag: '🇹🇳'
  },
  {
    code: 'DZ',
    name: 'アルジェリア',
    nameEn: 'Algeria',
    dialCode: '+213',
    flag: '🇩🇿'
  },
  {
    code: 'MA',
    name: 'モロッコ',
    nameEn: 'Morocco',
    dialCode: '+212',
    flag: '🇲🇦'
  },
  {
    code: 'MR',
    name: 'モーリタニア',
    nameEn: 'Mauritania',
    dialCode: '+222',
    flag: '🇲🇷'
  },
  { code: 'BJ', name: 'ベナン', nameEn: 'Benin', dialCode: '+229', flag: '🇧🇯' },
  { code: 'TG', name: 'トーゴ', nameEn: 'Togo', dialCode: '+228', flag: '🇹🇬' },
  {
    code: 'GN',
    name: 'ギニア',
    nameEn: 'Guinea',
    dialCode: '+224',
    flag: '🇬🇳'
  },
  {
    code: 'GW',
    name: 'ギニアビサウ',
    nameEn: 'Guinea-Bissau',
    dialCode: '+245',
    flag: '🇬🇼'
  },
  {
    code: 'SL',
    name: 'シエラレオネ',
    nameEn: 'Sierra Leone',
    dialCode: '+232',
    flag: '🇸🇱'
  },
  {
    code: 'LR',
    name: 'リベリア',
    nameEn: 'Liberia',
    dialCode: '+231',
    flag: '🇱🇷'
  },
  {
    code: 'GM',
    name: 'ガンビア',
    nameEn: 'Gambia',
    dialCode: '+220',
    flag: '🇬🇲'
  },
  {
    code: 'CV',
    name: 'カーボベルデ',
    nameEn: 'Cape Verde',
    dialCode: '+238',
    flag: '🇨🇻'
  },
  {
    code: 'ST',
    name: 'サントメ・プリンシペ',
    nameEn: 'São Tomé and Príncipe',
    dialCode: '+239',
    flag: '🇸🇹'
  },
  {
    code: 'GQ',
    name: '赤道ギニア',
    nameEn: 'Equatorial Guinea',
    dialCode: '+240',
    flag: '🇬🇶'
  },
  { code: 'GA', name: 'ガボン', nameEn: 'Gabon', dialCode: '+241', flag: '🇬🇦' },
  {
    code: 'CG',
    name: 'コンゴ共和国',
    nameEn: 'Republic of the Congo',
    dialCode: '+242',
    flag: '🇨🇬'
  },
  {
    code: 'CD',
    name: 'コンゴ民主共和国',
    nameEn: 'Democratic Republic of the Congo',
    dialCode: '+243',
    flag: '🇨🇩'
  },
  {
    code: 'BW',
    name: 'ボツワナ',
    nameEn: 'Botswana',
    dialCode: '+267',
    flag: '🇧🇼'
  },
  {
    code: 'NA',
    name: 'ナミビア',
    nameEn: 'Namibia',
    dialCode: '+264',
    flag: '🇳🇦'
  },
  {
    code: 'SZ',
    name: 'エスワティニ',
    nameEn: 'Eswatini',
    dialCode: '+268',
    flag: '🇸🇿'
  },
  {
    code: 'LS',
    name: 'レソト',
    nameEn: 'Lesotho',
    dialCode: '+266',
    flag: '🇱🇸'
  },
  {
    code: 'ZW',
    name: 'ジンバブエ',
    nameEn: 'Zimbabwe',
    dialCode: '+263',
    flag: '🇿🇼'
  },
  {
    code: 'MU',
    name: 'モーリシャス',
    nameEn: 'Mauritius',
    dialCode: '+230',
    flag: '🇲🇺'
  },
  {
    code: 'SC',
    name: 'セーシェル',
    nameEn: 'Seychelles',
    dialCode: '+248',
    flag: '🇸🇨'
  },
  {
    code: 'KM',
    name: 'コモロ',
    nameEn: 'Comoros',
    dialCode: '+269',
    flag: '🇰🇲'
  },
  {
    code: 'YT',
    name: 'マヨット',
    nameEn: 'Mayotte',
    dialCode: '+262',
    flag: '🇾🇹'
  },
  {
    code: 'RE',
    name: 'レユニオン',
    nameEn: 'Réunion',
    dialCode: '+262',
    flag: '🇷🇪'
  },
  {
    code: 'AF',
    name: 'アフガニスタン',
    nameEn: 'Afghanistan',
    dialCode: '+93',
    flag: '🇦🇫'
  },
  {
    code: 'AM',
    name: 'アルメニア',
    nameEn: 'Armenia',
    dialCode: '+374',
    flag: '🇦🇲'
  },
  {
    code: 'AZ',
    name: 'アゼルバイジャン',
    nameEn: 'Azerbaijan',
    dialCode: '+994',
    flag: '🇦🇿'
  },
  {
    code: 'BH',
    name: 'バーレーン',
    nameEn: 'Bahrain',
    dialCode: '+973',
    flag: '🇧🇭'
  },
  {
    code: 'BT',
    name: 'ブータン',
    nameEn: 'Bhutan',
    dialCode: '+975',
    flag: '🇧🇹'
  },
  {
    code: 'BN',
    name: 'ブルネイ',
    nameEn: 'Brunei',
    dialCode: '+673',
    flag: '🇧🇳'
  },
  {
    code: 'KH',
    name: 'カンボジア',
    nameEn: 'Cambodia',
    dialCode: '+855',
    flag: '🇰🇭'
  },
  {
    code: 'LK',
    name: 'スリランカ',
    nameEn: 'Sri Lanka',
    dialCode: '+94',
    flag: '🇱🇰'
  },
  {
    code: 'GE',
    name: 'ジョージア',
    nameEn: 'Georgia',
    dialCode: '+995',
    flag: '🇬🇪'
  },
  {
    code: 'HK',
    name: '香港',
    nameEn: 'Hong Kong',
    dialCode: '+852',
    flag: '🇭🇰'
  },
  { code: 'IQ', name: 'イラク', nameEn: 'Iraq', dialCode: '+964', flag: '🇮🇶' },
  { code: 'IR', name: 'イラン', nameEn: 'Iran', dialCode: '+98', flag: '🇮🇷' },
  {
    code: 'JO',
    name: 'ヨルダン',
    nameEn: 'Jordan',
    dialCode: '+962',
    flag: '🇯🇴'
  },
  {
    code: 'KZ',
    name: 'カザフスタン',
    nameEn: 'Kazakhstan',
    dialCode: '+7',
    flag: '🇰🇿'
  },
  {
    code: 'KW',
    name: 'クウェート',
    nameEn: 'Kuwait',
    dialCode: '+965',
    flag: '🇰🇼'
  },
  {
    code: 'KG',
    name: 'キルギス',
    nameEn: 'Kyrgyzstan',
    dialCode: '+996',
    flag: '🇰🇬'
  },
  { code: 'LA', name: 'ラオス', nameEn: 'Laos', dialCode: '+856', flag: '🇱🇦' },
  {
    code: 'LB',
    name: 'レバノン',
    nameEn: 'Lebanon',
    dialCode: '+961',
    flag: '🇱🇧'
  },
  { code: 'MO', name: 'マカオ', nameEn: 'Macau', dialCode: '+853', flag: '🇲🇴' },
  {
    code: 'MV',
    name: 'モルディブ',
    nameEn: 'Maldives',
    dialCode: '+960',
    flag: '🇲🇻'
  },
  {
    code: 'MN',
    name: 'モンゴル',
    nameEn: 'Mongolia',
    dialCode: '+976',
    flag: '🇲🇳'
  },
  {
    code: 'MM',
    name: 'ミャンマー',
    nameEn: 'Myanmar',
    dialCode: '+95',
    flag: '🇲🇲'
  },
  {
    code: 'NP',
    name: 'ネパール',
    nameEn: 'Nepal',
    dialCode: '+977',
    flag: '🇳🇵'
  },
  {
    code: 'OM',
    name: 'オマーン',
    nameEn: 'Oman',
    dialCode: '+968',
    flag: '🇴🇲'
  },
  {
    code: 'PS',
    name: 'パレスチナ',
    nameEn: 'Palestine',
    dialCode: '+970',
    flag: '🇵🇸'
  },
  {
    code: 'QA',
    name: 'カタール',
    nameEn: 'Qatar',
    dialCode: '+974',
    flag: '🇶🇦'
  },
  { code: 'TW', name: '台湾', nameEn: 'Taiwan', dialCode: '+886', flag: '🇹🇼' },
  {
    code: 'TJ',
    name: 'タジキスタン',
    nameEn: 'Tajikistan',
    dialCode: '+992',
    flag: '🇹🇯'
  },
  {
    code: 'TM',
    name: 'トルクメニスタン',
    nameEn: 'Turkmenistan',
    dialCode: '+993',
    flag: '🇹🇲'
  },
  {
    code: 'UZ',
    name: 'ウズベキスタン',
    nameEn: 'Uzbekistan',
    dialCode: '+998',
    flag: '🇺🇿'
  },
  {
    code: 'YE',
    name: 'イエメン',
    nameEn: 'Yemen',
    dialCode: '+967',
    flag: '🇾🇪'
  },
  {
    code: 'AL',
    name: 'アルバニア',
    nameEn: 'Albania',
    dialCode: '+355',
    flag: '🇦🇱'
  },
  {
    code: 'AD',
    name: 'アンドラ',
    nameEn: 'Andorra',
    dialCode: '+376',
    flag: '🇦🇩'
  },
  {
    code: 'BY',
    name: 'ベラルーシ',
    nameEn: 'Belarus',
    dialCode: '+375',
    flag: '🇧🇾'
  },
  {
    code: 'BA',
    name: 'ボスニア・ヘルツェゴビナ',
    nameEn: 'Bosnia and Herzegovina',
    dialCode: '+387',
    flag: '🇧🇦'
  },
  {
    code: 'BG',
    name: 'ブルガリア',
    nameEn: 'Bulgaria',
    dialCode: '+359',
    flag: '🇧🇬'
  },
  {
    code: 'HR',
    name: 'クロアチア',
    nameEn: 'Croatia',
    dialCode: '+385',
    flag: '🇭🇷'
  },
  {
    code: 'CY',
    name: 'キプロス',
    nameEn: 'Cyprus',
    dialCode: '+357',
    flag: '🇨🇾'
  },
  {
    code: 'EE',
    name: 'エストニア',
    nameEn: 'Estonia',
    dialCode: '+372',
    flag: '🇪🇪'
  },
  {
    code: 'FO',
    name: 'フェロー諸島',
    nameEn: 'Faroe Islands',
    dialCode: '+298',
    flag: '🇫🇴'
  },
  {
    code: 'GI',
    name: 'ジブラルタル',
    nameEn: 'Gibraltar',
    dialCode: '+350',
    flag: '🇬🇮'
  },
  {
    code: 'GL',
    name: 'グリーンランド',
    nameEn: 'Greenland',
    dialCode: '+299',
    flag: '🇬🇱'
  },
  {
    code: 'GG',
    name: 'ガーンジー',
    nameEn: 'Guernsey',
    dialCode: '+44',
    flag: '🇬🇬'
  },
  {
    code: 'IS',
    name: 'アイスランド',
    nameEn: 'Iceland',
    dialCode: '+354',
    flag: '🇮🇸'
  },
  {
    code: 'IM',
    name: 'マン島',
    nameEn: 'Isle of Man',
    dialCode: '+44',
    flag: '🇮🇲'
  },
  {
    code: 'JE',
    name: 'ジャージー',
    nameEn: 'Jersey',
    dialCode: '+44',
    flag: '🇯🇪'
  },
  {
    code: 'XK',
    name: 'コソボ',
    nameEn: 'Kosovo',
    dialCode: '+383',
    flag: '🇽🇰'
  },
  {
    code: 'LV',
    name: 'ラトビア',
    nameEn: 'Latvia',
    dialCode: '+371',
    flag: '🇱🇻'
  },
  {
    code: 'LI',
    name: 'リヒテンシュタイン',
    nameEn: 'Liechtenstein',
    dialCode: '+423',
    flag: '🇱🇮'
  },
  {
    code: 'LT',
    name: 'リトアニア',
    nameEn: 'Lithuania',
    dialCode: '+370',
    flag: '🇱🇹'
  },
  {
    code: 'LU',
    name: 'ルクセンブルク',
    nameEn: 'Luxembourg',
    dialCode: '+352',
    flag: '🇱🇺'
  },
  { code: 'MT', name: 'マルタ', nameEn: 'Malta', dialCode: '+356', flag: '🇲🇹' },
  {
    code: 'MD',
    name: 'モルドバ',
    nameEn: 'Moldova',
    dialCode: '+373',
    flag: '🇲🇩'
  },
  {
    code: 'MC',
    name: 'モナコ',
    nameEn: 'Monaco',
    dialCode: '+377',
    flag: '🇲🇨'
  },
  {
    code: 'ME',
    name: 'モンテネグロ',
    nameEn: 'Montenegro',
    dialCode: '+382',
    flag: '🇲🇪'
  },
  {
    code: 'MK',
    name: '北マケドニア',
    nameEn: 'North Macedonia',
    dialCode: '+389',
    flag: '🇲🇰'
  },
  {
    code: 'SM',
    name: 'サンマリノ',
    nameEn: 'San Marino',
    dialCode: '+378',
    flag: '🇸🇲'
  },
  {
    code: 'RS',
    name: 'セルビア',
    nameEn: 'Serbia',
    dialCode: '+381',
    flag: '🇷🇸'
  },
  {
    code: 'SK',
    name: 'スロバキア',
    nameEn: 'Slovakia',
    dialCode: '+421',
    flag: '🇸🇰'
  },
  {
    code: 'SI',
    name: 'スロベニア',
    nameEn: 'Slovenia',
    dialCode: '+386',
    flag: '🇸🇮'
  },
  {
    code: 'UA',
    name: 'ウクライナ',
    nameEn: 'Ukraine',
    dialCode: '+380',
    flag: '🇺🇦'
  },
  {
    code: 'VA',
    name: 'バチカン',
    nameEn: 'Vatican City',
    dialCode: '+39',
    flag: '🇻🇦'
  },
  {
    code: 'AG',
    name: 'アンティグア・バーブーダ',
    nameEn: 'Antigua and Barbuda',
    dialCode: '+1',
    flag: '🇦🇬'
  },
  { code: 'BS', name: 'バハマ', nameEn: 'Bahamas', dialCode: '+1', flag: '🇧🇸' },
  {
    code: 'BB',
    name: 'バルバドス',
    nameEn: 'Barbados',
    dialCode: '+1',
    flag: '🇧🇧'
  },
  {
    code: 'BZ',
    name: 'ベリーズ',
    nameEn: 'Belize',
    dialCode: '+501',
    flag: '🇧🇿'
  },
  {
    code: 'BM',
    name: 'バミューダ',
    nameEn: 'Bermuda',
    dialCode: '+1',
    flag: '🇧🇲'
  },
  {
    code: 'BO',
    name: 'ボリビア',
    nameEn: 'Bolivia',
    dialCode: '+591',
    flag: '🇧🇴'
  },
  {
    code: 'VG',
    name: '英領ヴァージン諸島',
    nameEn: 'British Virgin Islands',
    dialCode: '+1',
    flag: '🇻🇬'
  },
  {
    code: 'KY',
    name: 'ケイマン諸島',
    nameEn: 'Cayman Islands',
    dialCode: '+1',
    flag: '🇰🇾'
  },
  {
    code: 'CR',
    name: 'コスタリカ',
    nameEn: 'Costa Rica',
    dialCode: '+506',
    flag: '🇨🇷'
  },
  { code: 'CU', name: 'キューバ', nameEn: 'Cuba', dialCode: '+53', flag: '🇨🇺' },
  {
    code: 'DM',
    name: 'ドミニカ',
    nameEn: 'Dominica',
    dialCode: '+1',
    flag: '🇩🇲'
  },
  {
    code: 'DO',
    name: 'ドミニカ共和国',
    nameEn: 'Dominican Republic',
    dialCode: '+1',
    flag: '🇩🇴'
  },
  {
    code: 'EC',
    name: 'エクアドル',
    nameEn: 'Ecuador',
    dialCode: '+593',
    flag: '🇪🇨'
  },
  {
    code: 'SV',
    name: 'エルサルバドル',
    nameEn: 'El Salvador',
    dialCode: '+503',
    flag: '🇸🇻'
  },
  {
    code: 'FK',
    name: 'フォークランド諸島',
    nameEn: 'Falkland Islands',
    dialCode: '+500',
    flag: '🇫🇰'
  },
  {
    code: 'GF',
    name: '仏領ギアナ',
    nameEn: 'French Guiana',
    dialCode: '+594',
    flag: '🇬🇫'
  },
  {
    code: 'GD',
    name: 'グレナダ',
    nameEn: 'Grenada',
    dialCode: '+1',
    flag: '🇬🇩'
  },
  {
    code: 'GP',
    name: 'グアドループ',
    nameEn: 'Guadeloupe',
    dialCode: '+590',
    flag: '🇬🇵'
  },
  {
    code: 'GT',
    name: 'グアテマラ',
    nameEn: 'Guatemala',
    dialCode: '+502',
    flag: '🇬🇹'
  },
  {
    code: 'GY',
    name: 'ガイアナ',
    nameEn: 'Guyana',
    dialCode: '+592',
    flag: '🇬🇾'
  },
  { code: 'HT', name: 'ハイチ', nameEn: 'Haiti', dialCode: '+509', flag: '🇭🇹' },
  {
    code: 'HN',
    name: 'ホンジュラス',
    nameEn: 'Honduras',
    dialCode: '+504',
    flag: '🇭🇳'
  },
  {
    code: 'JM',
    name: 'ジャマイカ',
    nameEn: 'Jamaica',
    dialCode: '+1',
    flag: '🇯🇲'
  },
  {
    code: 'MQ',
    name: 'マルティニーク',
    nameEn: 'Martinique',
    dialCode: '+596',
    flag: '🇲🇶'
  },
  {
    code: 'MS',
    name: 'モントセラト',
    nameEn: 'Montserrat',
    dialCode: '+1',
    flag: '🇲🇸'
  },
  {
    code: 'NI',
    name: 'ニカラグア',
    nameEn: 'Nicaragua',
    dialCode: '+505',
    flag: '🇳🇮'
  },
  {
    code: 'PA',
    name: 'パナマ',
    nameEn: 'Panama',
    dialCode: '+507',
    flag: '🇵🇦'
  },
  {
    code: 'PY',
    name: 'パラグアイ',
    nameEn: 'Paraguay',
    dialCode: '+595',
    flag: '🇵🇾'
  },
  {
    code: 'PR',
    name: 'プエルトリコ',
    nameEn: 'Puerto Rico',
    dialCode: '+1',
    flag: '🇵🇷'
  },
  {
    code: 'BL',
    name: 'サン・バルテルミー',
    nameEn: 'Saint Barthélemy',
    dialCode: '+590',
    flag: '🇧🇱'
  },
  {
    code: 'KN',
    name: 'セントキッツ・ネイビス',
    nameEn: 'Saint Kitts and Nevis',
    dialCode: '+1',
    flag: '🇰🇳'
  },
  {
    code: 'LC',
    name: 'セントルシア',
    nameEn: 'Saint Lucia',
    dialCode: '+1',
    flag: '🇱🇨'
  },
  {
    code: 'MF',
    name: 'サン・マルタン',
    nameEn: 'Saint Martin',
    dialCode: '+590',
    flag: '🇲🇫'
  },
  {
    code: 'PM',
    name: 'サンピエール・ミクロン',
    nameEn: 'Saint Pierre and Miquelon',
    dialCode: '+508',
    flag: '🇵🇲'
  },
  {
    code: 'VC',
    name: 'セントビンセント・グレナディーン',
    nameEn: 'Saint Vincent and the Grenadines',
    dialCode: '+1',
    flag: '🇻🇨'
  },
  {
    code: 'SR',
    name: 'スリナム',
    nameEn: 'Suriname',
    dialCode: '+597',
    flag: '🇸🇷'
  },
  {
    code: 'TT',
    name: 'トリニダード・トバゴ',
    nameEn: 'Trinidad and Tobago',
    dialCode: '+1',
    flag: '🇹🇹'
  },
  {
    code: 'TC',
    name: 'タークス・カイコス諸島',
    nameEn: 'Turks and Caicos Islands',
    dialCode: '+1',
    flag: '🇹🇨'
  },
  {
    code: 'UY',
    name: 'ウルグアイ',
    nameEn: 'Uruguay',
    dialCode: '+598',
    flag: '🇺🇾'
  },
  {
    code: 'VE',
    name: 'ベネズエラ',
    nameEn: 'Venezuela',
    dialCode: '+58',
    flag: '🇻🇪'
  },
  {
    code: 'VI',
    name: '米領ヴァージン諸島',
    nameEn: 'U.S. Virgin Islands',
    dialCode: '+1',
    flag: '🇻🇮'
  },
  {
    code: 'AS',
    name: '米領サモア',
    nameEn: 'American Samoa',
    dialCode: '+1',
    flag: '🇦🇸'
  },
  {
    code: 'CK',
    name: 'クック諸島',
    nameEn: 'Cook Islands',
    dialCode: '+682',
    flag: '🇨🇰'
  },
  {
    code: 'FJ',
    name: 'フィジー',
    nameEn: 'Fiji',
    dialCode: '+679',
    flag: '🇫🇯'
  },
  {
    code: 'PF',
    name: '仏領ポリネシア',
    nameEn: 'French Polynesia',
    dialCode: '+689',
    flag: '🇵🇫'
  },
  { code: 'GU', name: 'グアム', nameEn: 'Guam', dialCode: '+1', flag: '🇬🇺' },
  {
    code: 'KI',
    name: 'キリバス',
    nameEn: 'Kiribati',
    dialCode: '+686',
    flag: '🇰🇮'
  },
  {
    code: 'MH',
    name: 'マーシャル諸島',
    nameEn: 'Marshall Islands',
    dialCode: '+692',
    flag: '🇲🇭'
  },
  {
    code: 'FM',
    name: 'ミクロネシア',
    nameEn: 'Micronesia',
    dialCode: '+691',
    flag: '🇫🇲'
  },
  {
    code: 'NC',
    name: 'ニューカレドニア',
    nameEn: 'New Caledonia',
    dialCode: '+687',
    flag: '🇳🇨'
  },
  { code: 'NU', name: 'ニウエ', nameEn: 'Niue', dialCode: '+683', flag: '🇳🇺' },
  {
    code: 'NF',
    name: 'ノーフォーク島',
    nameEn: 'Norfolk Island',
    dialCode: '+672',
    flag: '🇳🇫'
  },
  {
    code: 'MP',
    name: '北マリアナ諸島',
    nameEn: 'Northern Mariana Islands',
    dialCode: '+1',
    flag: '🇲🇵'
  },
  { code: 'PW', name: 'パラオ', nameEn: 'Palau', dialCode: '+680', flag: '🇵🇼' },
  {
    code: 'PG',
    name: 'パプアニューギニア',
    nameEn: 'Papua New Guinea',
    dialCode: '+675',
    flag: '🇵🇬'
  },
  {
    code: 'PN',
    name: 'ピトケアン諸島',
    nameEn: 'Pitcairn Islands',
    dialCode: '+64',
    flag: '🇵🇳'
  },
  { code: 'WS', name: 'サモア', nameEn: 'Samoa', dialCode: '+685', flag: '🇼🇸' },
  {
    code: 'SB',
    name: 'ソロモン諸島',
    nameEn: 'Solomon Islands',
    dialCode: '+677',
    flag: '🇸🇧'
  },
  {
    code: 'TK',
    name: 'トケラウ',
    nameEn: 'Tokelau',
    dialCode: '+690',
    flag: '🇹🇰'
  },
  { code: 'TO', name: 'トンガ', nameEn: 'Tonga', dialCode: '+676', flag: '🇹🇴' },
  {
    code: 'TV',
    name: 'ツバル',
    nameEn: 'Tuvalu',
    dialCode: '+688',
    flag: '🇹🇻'
  },
  {
    code: 'VU',
    name: 'バヌアツ',
    nameEn: 'Vanuatu',
    dialCode: '+678',
    flag: '🇻🇺'
  },
  {
    code: 'WF',
    name: 'ウォリス・フツナ',
    nameEn: 'Wallis and Futuna',
    dialCode: '+681',
    flag: '🇼🇫'
  }
]

export const getCountryByDialCode = (
  dialCode: string
): CountryCode | undefined => {
  return countryCodeList.find(country => country.dialCode === dialCode)
}

export const getCountryByCode = (code: string): CountryCode | undefined => {
  return countryCodeList.find(country => country.code === code)
}

export const DEFAULT_COUNTRY_CODE = '+81'
export const DEFAULT_COUNTRY = 'JP'
